import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower, fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { TableColumn, genFormattedColumn } from '../../../../components/tables/Table'
import { compliancesClient } from '../../../../utils/apollo/api'
import { getQueryParam } from '../../../../utils/helpers/url'
import { usePlaceNonCompliances } from '../_load/PlaceNonCompliancesLoader'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import IconCount from '../../../../components/shapes/IconCount'
import ListCounter from '../../../../components/helpers/ListCounter'
import NonCompliancesTable from '../nonCompliances/table/NonCompliancesTable'
import Text, { SmallText } from '../../../../packages/kiti/components/presentation/Text'

const NonComplianceTable = () => {
  const { t } = useTranslation()
  const origin = getQueryParam('origin') || 'serviceOrder'

  const data = usePlaceNonCompliances()

  const columns = [
    {
      label: 'Local/Pessoa',
      headerSideContent: (
        <>
          <ListCounter
            client={compliancesClient}
            entity="placeNonCompliances"
            filterName="PlaceNonComplianceFilter"
            filters={{ origins: origin }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: ['place', 'name'],
      sortIndex: false,
      flex: 4,
      render: (value, record) => (
        <>
          <Text bold size="h6" color="dark2" breakWord>
            {capitalizeAllIfLower(value)}
          </Text>

          <SmallText size="xxsmall" color="dark3" breakWord>
            {capitalizeAllIfLower(record.place?.resume)}
          </SmallText>
        </>
      )
    },

    {
      label: 'Total',
      dataIndex: 'nonCompliancesCount',
      sortIndex: 'NON_COMPLIANCES_COUNT',
      flex: 1,
      render: (value, record, index, { toggleExpand }) => (
        <IconCount value={value} onClick={toggleExpand} icon="BsListTask" />
      ),
      renderExpand: record => <NonCompliancesTable placeId={record.place.id} />
    },

    {
      label: '# abertas',
      dataIndex: 'openNonCompliancesCount',
      sortIndex: 'OPEN_NON_COMPLIANCES_COUNT',
      render: value => (
        <TableColumn color={!!value ? COLORS.red : COLORS.light3} strong>
          {value}
        </TableColumn>
      ),
      flex: 1
    },

    {
      label: '# concluidas',
      dataIndex: 'doneNonCompliancesCount',
      sortIndex: 'DONE_NON_COMPLIANCES_COUNT',
      render: value => (
        <TableColumn color={!!value ? COLORS.green : COLORS.light3} strong>
          {value}
        </TableColumn>
      ),
      flex: 1
    },

    {
      label: `Primeira ocorrência`,
      dataIndex: 'startDate',
      sortIndex: 'START_DATE',
      render: genFormattedColumn(fromNow),
      flex: 1.5
    },

    {
      label: 'Data de conclusão',
      dataIndex: 'endDate',
      sortIndex: false,
      render: genFormattedColumn((value, record) => (record.openNonCompliancesCount > 0 ? () => null : fromNow(value))),
      flex: 1.5
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" data={data} inPanel />
}

export default NonComplianceTable
